export enum TransactionStatus {
  INITIALIZED = 'INITIALIZED',
  AUTHORIZED = 'AUTHORIZED',
  FAILED = 'FAILED',
  REVERSED = 'REVERSED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
}

export enum TransactionProvider {
  WEBPAY = 'WEBPAY',
}

export enum TransactionPurpose {
  WARRANTY_PREMIUM = 'WARRANTY_PREMIUM',
}

export type Transaction = {
  id: string;
  amount: number;
  status: TransactionStatus;
  provider: TransactionProvider;
  refundedAmount: number;
  token: string | null;
  url: string | null;
  createdAt: string;
  updatedAt: string;
};

export const TRANSACTION_VCI = {
  TSY: 'Autenticación Exitosa',
  TSN: 'Autenticación Rechazada',
  NP: 'No Participa, sin autenticación',
  U3: 'Falla conexión, Autenticación Rechazada',
  INV: 'Datos Inválidos',
  A: 'Intentó',
  CNP1: 'Comercio no participa',
  EOP: 'Error operacional',
  BNA: 'BIN no adherido',
  ENA: 'Emisor no adherido',
};

export type VCI = keyof typeof TRANSACTION_VCI;

export const TRANSACTION_STATUS = {
  INITIALIZED: 'INITIALIZED',
  AUTHORIZED: 'AUTHORIZED',
  REVERSED: 'REVERSED',
  FAILED: 'FAILED',
  NULLIFIED: 'NULLIFIED',
  PARTIALLY_NULLIFIED: 'PARTIALLY_NULLIFIED',
  CAPTURED: 'CAPTURED',
};

export type STATUS = keyof typeof TRANSACTION_STATUS;

export const TRANSACTION_PAYMENT = {
  VD: 'Venta Débito',
  VN: 'Venta Normal',
  VC: 'Venta en cuotas',
  SI: '3 cuotas sin interés',
  S2: '2 cuotas sin interés',
  NC: 'N Cuotas sin interés',
  VP: 'Venta Prepago',
};

export type PAYMENT = keyof typeof TRANSACTION_PAYMENT;

export type WebpayMetadata = {
  vci: VCI;
  amount: number;
  status: STATUS;
  buy_order: string;
  session_id: string;
  card_detail: { card_number?: string };
  accounting_date: string;
  transaction_date: string;
  authorization_code: string;
  payment_type_code: PAYMENT;
  response_code: number;
  installments_amount: number | null;
  installments_number: number | null;
  balance: number | null;
};

export type ProviderMetadata = {
  [TransactionProvider.WEBPAY]: WebpayMetadata;
};

export type GetResponse<P extends TransactionProvider = TransactionProvider> =
  Transaction & {
    provider: P;
    metadata: ProviderMetadata[P];
  };

export type CreateBody = {
  amount: number;
  provider: TransactionProvider;
  url: string;
  purpose: TransactionPurpose;
  requestId?: number;
};
